<template>
  <!-- van-tab 面板 SSR 不渲染、挂载后才撑开：挂载前预留高度，避免把下方模块往下推（CLS） -->
  <div
    class="mx-4 rounded-xl member-search"
    :class="{ 'min-h-[235px]': !isMounted }"
  >
    <van-tabs
      v-model:active="activeSearch"
      :class="'search-tab'"
      animated
      duration="0"
      title-active-color="#FF6A00"
      :style="{
        '--van-tabs-bottom-bar-width': '16px',
        '--van-tabs-bottom-bar-height': '2px',
        '--van-tabs-bottom-bar-color': '#ff6a00',
        '--van-tabs-line-height': '40px',
      }"
    >
      <van-tab
        v-for="[key, value] in Object.entries(tabList)"
        :key="key"
        :name="key"
        :title-class="$i18n.locale === 'zh-CN' ? 'van-tab-cn' : 'van-tab-en'"
      >
        <template #title>
          <span class="tab-title">{{ $t(value) }}</span></template
        >

        <!-- 仅当前 tab 挂载内容，避免 animated 下 aria-hidden 面板里仍有可聚焦按钮 -->
        <div v-if="activeSearch === key" class="tab-content">
          <template v-if="key === 'location'">
            <div class="company-search-wrap" @click="eventClickCountry">
              <div class="company-search-wrap-box">
                <div
                  v-if="isHaveCountry"
                  class="company-search-wrap-box-location company-search-wrap-box-location-selected"
                >
                  <span
                    class="iconfont icon-icon_search_position_nor size-6 company-search-wrap-box-location-icon"
                  />
                  <span>{{ country[labelKey] }}</span>

                  <IconClean
                    class="ml-auto size-6"
                    @click.stop="resetCountry"
                  />
                </div>
                <div v-else class="company-search-wrap-box-location">
                  <span
                    class="iconfont icon-icon_search_position_nor size-6 company-search-wrap-box-location-icon"
                  />
                  <span>{{ $t('companySearch.search.allCounties') }}</span>
                </div>
              </div>
            </div>
            <div
              class="border-l-divide-line-color h-[1px] bg-[#E7E7E8] my-[2px] mx-6"
            />
            <div class="company-search-wrap !mt-1">
              <div
                class="company-search-wrap-box"
                :class="{
                  'company-search-wrap-box-small-padding': isHaveCity,
                }"
                @click="eventClickCity"
              >
                <div
                  v-if="isHaveCity"
                  class="company-search-wrap-box-location company-search-wrap-box-location-selected"
                >
                  <span
                    class="iconfont icon-icon_search_position_nor size-6 company-search-wrap-box-location-icon"
                  />
                  <span class="max-w-64 truncate">{{ city[labelKey] }}</span>
                  <IconClean class="ml-auto size-6" @click.stop="resetCity" />
                </div>
                <div v-else class="company-search-wrap-box-location">
                  <span
                    class="iconfont icon-icon_search_position_nor size-6 company-search-wrap-box-location-icon"
                  />
                  <span>{{ $t('companySearch.search.allCities') }}</span>
                </div>
              </div>
            </div>
          </template>
          <template v-if="key === 'port'">
            <div class="company-search-wrap" @click="eventClickPort">
              <div
                class="company-search-wrap-box"
                :class="{
                  'company-search-wrap-box-small-padding': isHavePort,
                }"
              >
                <ul
                  v-if="isHavePort"
                  class="company-search-wrap-box-location-port company-search-wrap-box-location-selected"
                >
                  <span
                    class="iconfont icon-icon_search_port size-6 company-search-wrap-box-location-icon"
                  />
                  <li v-for="portItem in port" :key="portItem.id">
                    {{ portItem[portLabelKey] }}
                  </li>
                </ul>
                <div v-else class="company-search-wrap-box-location">
                  <span
                    class="iconfont icon-icon_search_port size-6 company-search-wrap-box-location-icon"
                  />
                  <span>{{ $t('companySearch.search.allPorts') }}</span>
                </div>
              </div>
              <div
                class="border-l-divide-line-color h-[1px] bg-[#E7E7E8] mt-[6px] mx-4 mb-1"
              />
            </div>
          </template>
          <template v-if="key === 'id'">
            <div class="company-search-wrap">
              <VanSearch
                v-model="memberId"
                class="company-search-wrap-box"
                left-icon=""
                :placeholder="$t('companySearch.search.memberID')"
                :clearable="false"
              >
                <template #left>
                  <span
                    :class="memberId && 'company-search-icon-selected'"
                    class="iconfont icon-icon_search_id size-6 company-search-icon"
                  />
                </template>
                <template #right-icon>
                  <IconClean
                    v-if="memberId"
                    class="ml-auto size-6"
                    @click.stop="() => (memberId = '')"
                  />
                </template>
              </VanSearch>
              <div
                class="border-l-divide-line-color h-[1px] bg-[#E7E7E8] mt-[6px] mx-5 mb-1"
              />
            </div>
          </template>
          <template v-if="key === 'name'">
            <div class="company-search-wrap">
              <VanSearch
                v-model="companyName"
                class="company-search-wrap-box"
                left-icon=""
                :placeholder="$t('companySearch.search.companyName')"
                :clearable="false"
              >
                <template #left>
                  <span
                    :class="companyName && 'company-search-icon-selected'"
                    class="iconfont icon-icon_search_company size-6 company-search-icon"
                  />
                </template>
                <template #right-icon>
                  <IconClean
                    v-if="companyName"
                    class="ml-auto size-6"
                    @click.stop="() => (companyName = '')"
                  />
                </template>
              </VanSearch>
              <div
                class="border-l-divide-line-color h-[1px] bg-[#E7E7E8] mt-[6px] mx-5 mb-1"
              />
            </div>
          </template>
          <div class="company-search-button">
            <div class="company-search-button-wrap">
              <VanButton type="primary" block @click="eventSearch">{{
                getCnOrEn('搜索公司', 'Search Company')
              }}</VanButton>
            </div>
            <div class="company-search-button-slot">
              <slot name="button-right" />
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <CustomPopup
      v-model="isShowPopup"
      :title="$t(currentPopupTitle)"
      :confirm-text="$t('home.header.Products.Confirm')"
      :cancel-text="$t('home.header.Products.Cancel')"
      :is-show-confirm="activeSearch === 'location' ? false : true"
      :slot-key="activeSearch === 'port' ? 'port' : ''"
      @close="eventPopupClose"
    >
      <!-- 国家城市：仅弹层打开时挂载，避免首屏拉起整棵选择器树 -->
      <SearchLocation
        v-if="isShowPopup && activeSearch === 'location'"
        key="location"
        ref="locationRef"
        v-model:active-tab="locationActiveTab"
        v-model:country="country"
        v-model:city="city"
        :label-key="labelKey"
        :country-options="{
          multiple: false,
          placeholder: $t('companySearch.search.country'),
        }"
        :city-options="{
          multiple: false,
          placeholder: $t('companySearch.search.city'),
        }"
        @update:country="
          locationActiveTab === 'country' && (isShowPopup = false)
        "
        @update:city="handleUpdateCity"
      />

      <!-- 港口 -->
      <SearchPortSearch
        v-if="isShowPopup && activeSearch === 'port'"
        key="port"
        v-model="port"
        v-model:query="portQuery"
        value-key="id"
        :option-list="portOptionList"
        :placeholder="$t('companySearch.search.port')"
        :loading="portIsLoading"
        :label-key="portLabelKey"
        slot-key="port"
        :multiple="true"
        @data="asyncPortList"
        @load-more-data="eventPortLoadMoreData"
      />
    </CustomPopup>
  </div>
</template>

<script lang="ts" setup>
  import { IconClean, type SearchLocation } from '#components'
  import {
    getCountry,
    getSeaAndAirPostListApi,
    type CommonParams,
    type SeaportAirportInterface,
  } from '~/api/common'
  import {
    CUSTOM_POPUP_TITLE,
    CUSTOM_TAB_TITLE,
    PAGE_SIZE,
    type CompanySearchType,
    type CountryCityModules,
  } from '../Search/constant'

  const activeSearch = ref('location')

  const isMounted = ref(false)
  onMounted(() => {
    isMounted.value = true
  })

  // 数据多语言
  const labelKey = useLabelKey({
    'zh-CN': 'nameCn',
    default: 'nameEn',
  })

  const portLabelKey = useLabelKey({
    'zh-CN': 'displayNameCn',
    default: 'displayNameEn',
  })

  const tabList = {
    location: 'companySearch.search.location',
    name: 'companySearch.search.name',
    id: 'companySearch.search.id',
    port: 'companySearch.search.port',
  }

  // 国家城市
  const locationActiveTab = ref<CountryCityModules>('country')
  const locationRef = ref<InstanceType<typeof SearchLocation>>()
  // 展示 popup
  const isShowPopup = ref(false)
  /** 关闭弹层后短时间禁止再次打开，避免手机点击穿透又弹一次 */
  let popupReopenLockUntil = 0
  const lockPopupReopen = () => {
    popupReopenLockUntil = Date.now() + 400
  }
  const canOpenPopup = () => Date.now() >= popupReopenLockUntil

  // 当前展示的标题
  const currentPopupTitle = computed(() => {
    let current = ''
    if (activeSearch.value === 'location') {
      current = CUSTOM_POPUP_TITLE[locationActiveTab.value] || ''
    } else {
      current = CUSTOM_TAB_TITLE[activeSearch.value as CompanySearchType] || ''
    }
    return current
  })

  function eventPopupClose() {
    lockPopupReopen()
  }

  // 点击出国家
  function eventClickCountry() {
    if (!canOpenPopup()) return
    locationActiveTab.value = 'country'
    isShowPopup.value = true
  }
  // 点击出城市
  function eventClickCity() {
    if (!canOpenPopup()) return
    locationActiveTab.value = 'city'
    isShowPopup.value = true
  }
  // 点击出港口
  function eventClickPort() {
    if (!canOpenPopup()) return
    isShowPopup.value = true
  }

  // 弹层卸载 SearchLocation 后仍能回填国家
  async function handleUpdateCity() {
    isShowPopup.value = false
    const countryId = city.value?.countryId
    if (!countryId || country.value?.id === countryId) return
    try {
      const data = await getCountry({
        sort: 'nameEn',
        current: 1,
        size: 1,
        appointSearch: [
          {
            name: 'countryId',
            val: JSON.stringify([countryId]),
          },
        ],
      })
      const countryData = data.records?.[0]
      if (countryData) {
        country.value = countryData
      }
    } catch (e) {
      console.error(e)
    }
  }

  const country = ref<any>(null)
  const city = ref<any>(null)
  const companyName = ref<any>('')
  const memberId = ref<any>('')
  const port = ref<any>(null)
  const portQuery = ref('')
  const portOptionList = ref<SeaportAirportInterface[]>([])
  const portIsLoading = ref(false)
  let portCurrent = 1
  let portTotal = 0
  let portPages = 0

  // 是否有国家
  const isHaveCountry = computed(() => !_isEmpty(country.value))

  // 是否有城市
  const isHaveCity = computed(() => !_isEmpty(city.value))

  const isHavePort = computed(() => !_isEmpty(port.value))

  // 重置国家
  const resetCountry = () => {
    country.value = null
    city.value = null
    locationActiveTab.value = 'country'
  }

  // 重置城市
  const resetCity = () => {
    city.value = null
    locationActiveTab.value = 'city'
  }

  // ------------------------------------ port
  // 重置港口数据
  function resetPort() {
    portCurrent = 1
    portTotal = 0
    portPages = 0
    portOptionList.value = []
  }

  // 获取港口数据
  async function getPortList(
    idList: {
      id: number | string
      customSearchType: 'Seaport' | 'Airport'
    }[] = [],
  ) {
    // console.log('🍉 ~ Company.vue:486 ~ idList:', idList)
    try {
      if (!portIsLoading.value) {
        portIsLoading.value = true
        const params: CommonParams = {
          sort: 'nameEn',
          current: portCurrent,
          searchContent: portQuery.value,
          size: PAGE_SIZE,
        }
        if (idList.length > 0) {
          const seaportIds = idList
            .filter((i) => i.customSearchType === 'Seaport')
            .map((i) => i.id)
          const airportIds = idList
            .filter((i) => i.customSearchType === 'Airport')
            .map((i) => i.id)
          params.appointSearch = []
          if (seaportIds.length > 0) {
            params.appointSearch.push({
              name: 'seaportId',
              val: JSON.stringify(seaportIds),
            })
          }
          if (airportIds.length > 0) {
            params.appointSearch.push({
              name: 'airportId',
              val: JSON.stringify(airportIds),
            })
          }
        }
        // console.log('🍉 ~ Company.vue:495 ~ params:', params)

        const result = await getSeaAndAirPostListApi(params)
        portTotal = result.total
        portPages = result.pages
        if (portOptionList.value.length < portTotal) {
          portOptionList.value = _uniqBy(
            portOptionList.value.concat(result.records),
            'id',
          )
        }
      }
    } catch (e) {
      console.error(e)
      portOptionList.value = []
    } finally {
      portIsLoading.value = false
    }
  }

  // 处理 多选加载更多港口列表
  async function eventPortLoadMoreData() {
    try {
      if (!portIsLoading.value) {
        portIsLoading.value = true

        const params: CommonParams = {
          sort: 'nameEn',
          current: portCurrent,
          searchContent: portQuery.value,
          size: PAGE_SIZE,
        }
        const result = await getSeaAndAirPostListApi(params)

        portTotal = result.total
        portPages = result.pages

        // 搜索结果也要添加到最前面
        portOptionList.value = _uniqBy(
          portOptionList.value
            .slice(0, port.value ? port.value.length : 0)
            .concat(
              result.records.concat(
                portOptionList.value.slice(port.value ? port.value.length : 0),
              ),
            ), // 先新后旧
          'id',
        )
      }
    } catch (e) {
      console.error(e)
      portOptionList.value = []
    } finally {
      portIsLoading.value = false
    }
  }

  // 同步港口数据
  async function asyncPortList(isLoadMore: boolean = false) {
    // console.log(
    // '🍉 ~ Company.vue:575 ~ asyncPortList ~ isLoadMore:',
    // isLoadMore,
    // )
    try {
      if (!isLoadMore) {
        if (port.value && port.value.length > 0) {
          const portIdList = (port.value as SeaportAirportInterface[]).map(
            (item) => ({
              id: item.id,
              customSearchType: item.customSearchType,
            }),
          )
          await getPortList(portIdList)
          port.value = portOptionList.value.filter((item) => {
            return portIdList.some(
              (p) =>
                p.id === item.id &&
                p.customSearchType === item.customSearchType,
            )
          })
        } else {
          resetPort()
          getPortList()
        }
      } else if (portCurrent < portPages) {
        portCurrent += 1
        getPortList()
      }
    } catch (e) {
      console.error(e)
    }
  }
  // ------------------------------------
  async function eventSearch() {
    let searchData: any = {
      type: activeSearch.value,
      value: [],
    }

    switch (activeSearch.value) {
      case 'location':
        // 这里的 city.value 本身应该是对象（因为 SearchLocation 是 multiple: false）
        // 但为了 setRouteQuery 能正确生成 URL，我们可以保持数组形式传过去
        // setRouteQuery 内部会处理数组 join(',')
        searchData = {
          type: 'location',
          value: [
            country.value || { id: 0 },
            // 确保传给 setRouteQuery 的 city 是数组结构，方便它 map 生成字符串
            city.value
              ? Array.isArray(city.value)
                ? city.value
                : [city.value]
              : [],
          ],
        }
        break
      case 'name':
        searchData = {
          type: 'name',
          value: [companyName.value],
        }
        break
      case 'id':
        searchData = {
          type: 'id',
          value: [memberId.value],
        }
        break
      case 'port':
        searchData = {
          type: 'port',
          value: [port.value || []],
        }
        break
      default:
        searchData = {
          type: 'location',
          value: [{ id: 0 }, undefined],
        }
    }

    // 点击搜索时再加载 routeQuery，避免首页首屏同步解析大文件
    const { useCompanyRouteQuery } = await import('~/composables/routeQuery')
    const { setRouteQuery } = useCompanyRouteQuery()

    // 关键修复：补全 setRouteQuery 的参数
    // 传入空数组/false 重置其他筛选条件，并在最后传入 1 强制跳转第一页
    const { query: currentQuery, path } = await setRouteQuery(
      searchData,
      [], // membership
      [], // advantages
      undefined, // years
      [], // certs
      [], // routes
      false, // case
      false, // credit
      false, // jcvf
      false, // service
      [], // ship
      [], // air
      1, // page -> 强制重置为第1页
    )

    await navigateTo({
      path: path,
      query: currentQuery,
      // replace: true,
    })
  }
</script>

<style lang="scss" scoped>
  $active-color: #ff6a00;
  $active-background: rgb(205 106 0 / 0.1);
  $default-color: #444b61;
  $margin-x: 16px;

  @mixin radius-shadow {
    border-radius: 8px;
    box-shadow: 0 8px 40px 0 rgb(97 98 101 / 0.08);
  }

  @mixin wrap-center-width {
    margin-right: 4px;
    margin-left: 4px;
  }

  .member-search {
    .search-tab {
      :deep(.van-tabs__wrap) {
        border-radius: 12px 12px 0 0;

        .van-tabs__nav {
          background: transparent;

          .van-tab {
            // 清除Tab右侧的默认分隔边框
            border-right: none !important;

            // （可选）若仍有视觉分隔，补充清除其他可能的边框/伪元素
            border-left: none !important;
            box-shadow: none !important;
          }

          .tab-title {
            color: rgb(35 35 36 / 0.6);
          }
        }

        .van-tab-en {
          height: 32px;
          margin-top: 8px;
          margin-right: 0;
          margin-left: 0;
          background: #fff;
          background: linear-gradient(
            rgb(255 255 255 / 0.9) 0%,
            rgb(255 255 255 / 1) 100%
          );

          &:first-child {
            width: 77px;
            border-radius: 12px 0 0;
          }

          &:nth-child(2) {
            .tab-title {
              display: inline-flex;
              justify-content: center;
              width: 120px;
            }
          }

          &:nth-child(3) {
            .tab-title {
              display: inline-flex;
              justify-content: center;
              width: 72px;
            }
          }

          &:nth-last-child(2) {
            border-radius: 0 12px 0 0;
          }
        }

        .van-tab-cn {
          height: 32px;
          margin-top: 8px;
          margin-right: 0;
          margin-left: 0;

          // background: #fff;
          background: linear-gradient(
            rgb(255 255 255 / 0.9),
            rgb(255 255 255 / 1)
          ) !important;

          &:first-child {
            border-radius: 12px 0 0;
          }

          &:nth-last-child(2) {
            border-radius: 0 12px 0 0;
          }
        }

        .van-tab--active {
          height: 40px;
          padding-top: 8px;
          margin-top: 0;
          background: #fff;
          border-radius: 12px 12px 0 0 !important;

          .tab-title {
            color: #ff6a00;
          }
        }
      }

      .tab-title {
        @apply font-popSB;

        font-size: 13px;
        font-weight: 600;
        text-align: center;
      }

      .tab-content {
        // min-height: 179px;
        padding-bottom: 12px;
        background: #fff;
        border-radius: 0 0 12px 12px;
      }

      :deep(.van-tabs__content) {
        background-color: #fff;
        border-radius: 0 0 12px 12px;
      }
    }

    .company-search-wrap {
      @include wrap-center-width;
      // @include radius-shadow;

      margin-top: $margin-x;
      overflow: hidden;
      background: #fff;

      .company-search-wrap-box {
        width: 100%;
        padding: 12px;
        overflow-x: auto;
        white-space: nowrap;

        .company-search-icon {
          display: inline-block;
          flex-shrink: 0;
          margin-right: 8px;
          font-size: 16px;
          vertical-align: middle;
          color: #c9cfdb;
          fill: #c9cfdb;

          &::before {
            color: #c9cfdb;
          }
        }

        .company-search-icon-selected {
          color: #010d32;
          fill: #010d32;

          &::before {
            color: #000c31;
          }
        }

        .company-search-wrap-box-location-city,
        .company-search-wrap-box-location-port {
          display: flex;
          align-items: center;

          li {
            padding: 4px 8px;
            margin-right: 8px;
            font-size: 15px;
            font-weight: 400;
            color: #000c31;
            background: #f8f9fd;
            border-radius: 2px;

            &:last-child {
              margin-right: 0;
            }
          }
        }

        .company-search-wrap-box-location {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          height: 24px;

          &.company-search-wrap-box-location-selected {
            span {
              color: #000c31;
              fill: #ff6a00;
            }

            .company-search-wrap-box-location-icon {
              color: #010d32;
              fill: #010d32;

              &::before {
                color: #000c31;
              }
            }
          }

          .company-search-wrap-box-location-icon {
            display: inline-block;
            flex-shrink: 0;
            margin-right: 8px;
            font-size: 16px;
            vertical-align: middle;
            color: #c9cfdb;
            fill: #c9cfdb;
          }

          span {
            font-size: 15px;
            font-weight: 400;
            color: #c9cfdb;
          }
        }

        &.company-search-wrap-box-small-padding {
          // padding-top: 9px;
          // padding-bottom: 9px;
          padding: 12px;
        }
      }

      :deep(.van-search) {
        .van-search__content {
          padding-left: 0;
          background: unset;

          .van-cell {
            height: 24px;

            .van-field__body {
              font-size: 15px;
            }
          }
        }
      }
    }

    .company-search-button {
      display: flex;
      margin-top: 16px;
      margin-right: 16px;
      margin-left: 16px;

      .company-search-button-wrap {
        width: 100%;
        // box-shadow: 0 8px 40px 0 rgb(50 100 255 / 0.2);

        :deep(.van-button) {
          height: 48px;
          font-size: 15px;
          background: $active-color;
          background: linear-gradient(90deg, #ff5000 0%, #ff8f12 100%);
          border: none;
          border-radius: 12px;

          @apply font-popSB;
        }
      }

      .company-search-button-slot {
        flex-shrink: 0;
      }
    }
  }
</style>
